// Densité des tableaux choisie dans les préférences (SYS-P04). Module léger : la coquille le fournit sans charger
// TanStack Table (budget JS initial, apps/web/CLAUDE.md).
import { createContext } from 'react';

export type TableDensity = 'comfortable' | 'dense';

export const TableDensityContext = createContext<TableDensity>('comfortable');
